module.exports = __webpack_public_path__ + "static/media/HR-Background.6f6b315a.jpg";